import { BehaviorSubject } from "rxjs";
import { HandleResponse } from "../Healper/handleResponse";

const currentUserSubject = new BehaviorSubject(
  JSON.parse(localStorage.getItem("token"))
);
const authenticationService = {
  login,
  logout,
  isAuthenticated,
  currentUser: currentUserSubject.asObservable(),
  get currentUserValue() {
    return currentUserSubject.value;
  },
};

function login(name, pass) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name, pass }),
  };
  return (
    /* fetch(`http://localhost:5000/api/Login/Login`, requestOptions)*/
    fetch(`https://covidapi.ihpath.com/api/Login/Login`, requestOptions)
      .then(HandleResponse)
      .then((user) => {
        if (user.errors === undefined) {
          localStorage.setItem("token", JSON.stringify(user.token));
          currentUserSubject.next(user.token);
        }

        return user;
      })
  );
}

function logout() {
  // remove user from local storage to log user out

  localStorage.removeItem("token");
  currentUserSubject.next(null);
}
async function isAuthenticated() {
  const requestOptions = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + authenticationService.currentUserValue,
    },
  };
  if (authenticationService.currentUserValue) {
    /* return await fetch(
      `http://localhost:5000/api/Users/IsAuthenticated`,
      requestOptions
    )*/
    return await fetch(
      `https://covidapi.ihpath.com/api/Users/IsAuthenticated`,
      requestOptions
    )
      .then(HandleResponse)
      .then(() => {
        return true;
      })
      .catch(() => {
        logout();
        return false;
      });
  } else return false;
}
export default authenticationService;
